import { ref, computed } from 'vue'
import { MdIconEdit } from '@antiqua-dls/vue-components'
import i18n from 'src/assets/i18n/i18n'
import { useRouter } from 'vue-router'

export default {
  components: {
    MdIconEdit
  },
  props: {
    bannerURL: {
      type: String,
      default: null
    },
    logoURL: {
      type: String,
      default: null
    },
    foundryName: {
      type: String,
      default: ''
    },
    hasFoundryProfilePermission: {
      type: Boolean,
      default: false
    },
  },
  setup(props, { emit }) {

    const $t = i18n().global.t;
    const router = useRouter();
    const defaultBannerUrl = ref(require('./assets/default-banner.svg').default);
    const logoTooltipContent = ref($t('pages.dashboard.components.foundryBanner.logoTooltip'));
    const bannerTooltipContent = ref($t('pages.dashboard.components.foundryBanner.bannerTooltip'));
    const isMobile = window.innerWidth <= 600;
    const foundryNameInitials = computed(() => props.foundryName?.split(' ').map(word => word.charAt(0)).join('') || '')

    const brandYourProfile = () => {
      const sessionFoundryId = window.localStorage.getItem('sessionFoundryId');
      router.push(`/edit-foundry/${sessionFoundryId}`);
    }

    return {
      defaultBannerUrl,
      logoTooltipContent,
      bannerTooltipContent,
      isMobile,
      foundryNameInitials,
      brandYourProfile
    }
  },
}